<template>
  <div class="ml-auto welcome-wrapper">
    <loader ref="loader" />
    <div class="content mt-2 mb-5">
      <div class="d-flex">
        <h1>
          {{ $t("welcome.title") }}
        </h1>
        <!-- <MultiDropdown class="dropdown" /> -->
      </div>
      <div class="sub-title">
        {{ changePartnerLabelName(marketInfo, "welcome.sub-title") }}
      </div>
      <div class="description">
        <p v-html="whiteLabelText"></p>
        <!-- <p>
          {{ changePartnerLabelName(marketInfo, "welcome.description.text-1") }}
        </p>
        <p>
          {{ $t("welcome.description.text-2") }}
        </p>
        <p>
          {{ changePartnerLabelName(marketInfo, "welcome.description.text-3") }}
        </p> -->
      </div>
      <div class="d-flex">
        <!-- <CustomButton :name="$t('welcome.cancel')"
      className="button-default w-100"
      @handle-click="closeIframe"
        class="continue-btn cancel-btn"></CustomButton> -->
        <CustomButton
          :name="$t('welcome.continue')"
          className="button-default w-100"
          @handle-click="onContinue"
          class="continue-btn"
          :disabled="!termsConditions || continueLoading"
          :loader="continueLoading"
        ></CustomButton>
      </div>
      <div class="terms-conditions">
        <input type="checkbox" v-model="termsConditions" />
        <span>
          {{ $t("welcome.i-agree") }}
          <a
            class="text-orange cursor-pointer"
            v-bind:href="defaultTandCLink"
            target="_blank"
          >
            {{ $t("welcome.TnC") }}
          </a>
          {{ $t("welcome.and") }}
          <a
            class="text-orange cursor-pointer"
            v-bind:href="defaultPrivacyLink"
            target="_blank"
          >
            {{ $t("welcome.privacy-policy") }}
          </a>
          {{ changePartnerLabelName(marketInfo, "welcome.of-RF") }}
        </span>
      </div>
      <div class="partner-block clearfix">
        <span class="caption">{{ $t("welcome.caption") }}</span>
        <div class="logo-list d-flex">
          <img
            src="@/assets/img/bitcoin.png"
            alt="bitcoin"
            loading="lazy"
            decoding="async"
          />
          <img
            src="@/assets/img/concordium.svg"
            alt="concordium"
            class="concordium-logo"
            loading="lazy"
            decoding="async"
          />
          <img
            src="@/assets/img/ethereum.png"
            alt="ethereum"
            loading="lazy"
            decoding="async"
          />
        </div>
        <!-- <div class="link-wrap text-center">
          <span class="caption">{{ $t("welcome.full-list") }}</span>
        </div> -->
      </div>
      <!-- <div class="partner-block clearfix">
        <span class="caption">{{ $t("welcome.support") }}</span>
        <div class="logo-list d-flex">
          <img src="@/assets/img/coinbase.png" alt="coinbase" />
          <img src="@/assets/img/gemini.png" alt="gemini" />
          <img src="@/assets/img/binance.png" alt="binance" />
        </div>
      </div> -->
      <div class="partner-block clearfix mb-0">
        <span class="caption">{{ $t("welcome.trusted-companies") }} </span>
        <div class="logo-list d-flex" style="justify-content: center">
          <img
            style="margin-right: 40px"
            src="@/assets/img/skytours.png"
            alt="skytours"
            loading="lazy"
            decoding="async"
          />
          <img
            src="@/assets/img/beartax.png"
            alt="beartax"
            loading="lazy"
            decoding="async"
          />
          <!-- <img src="@/assets/img/banknote.png" alt="banknote" /> -->
        </div>
      </div>
    </div>
    <WhiteLabelTheme />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import CustomButton from "./customButton.vue";
import WhiteLabelTheme from "@/components/WhiteLabelTheme.vue";
import {
  getIntroPageText,
  getWhiteLabelPrivacyLink,
  getWhiteLabelTermsLink,
} from "@/utils/whiteLabelColors";
// import MultiDropdown from '../components/MultiDropdown.vue';
import { USER_TRACK_EVENTS } from "../store/modules/user/consts";
import { routeEnum } from "../store/modules/auth/enum";
import {
  paymentPageNeedsLoader,
  prefetchPaymentBootstrap,
} from "@/utils/paymentBootstrap";

export default {
  name: "Welcome",
  components: {
    CustomButton,
    WhiteLabelTheme,
  },
  data() {
    return {
      termsConditions: true,
      continueLoading: false,
    };
  },
  computed: {
    whiteLabelText() {
      const fallback = [
        this.$t("welcome.description.text-1"),
        this.$t("welcome.description.text-2"),
        this.$t("welcome.description.text-3"),
      ]
        .map((text) => `<p>${text}</p>`)
        .join("");
      return getIntroPageText(this.marketInfo, fallback);
    },
    ...mapGetters({
      marketInfo: "user/marketInfo",
    }),
    defaultTandCLink() {
      return getWhiteLabelTermsLink(this.marketInfo);
    },
    defaultPrivacyLink() {
      return getWhiteLabelPrivacyLink(this.marketInfo);
    },
  },
  mounted() {
    this.$refs.loader?.hide();
  },
  watch: {
    marketInfo: {
      handler(newVal) {
        if (newVal && Object.keys(newVal).length) {
          this.$refs.loader?.hide();
        }
      },
    },
  },
  methods: {
    async onContinue() {
      if (this.continueLoading) {
        return;
      }

      this.continueLoading = true;
      const cart = this.$store.getters["user/cart"];
      const showLoader =
        cart?.merchant_id && paymentPageNeedsLoader(this.$store, cart);
      if (showLoader) {
        this.$refs.loader?.start();
      }

      try {
        if (!this.$store.getters["auth/isAuth"]) {
          await this.$router.push({ name: "Sign in" });
          return;
        }

        await this.$router.push({ name: "Payment" });

        if (cart && Object.keys(cart).length) {
          prefetchPaymentBootstrap(this.$store, cart);
        }

        this.$store.dispatch(`user/${USER_TRACK_EVENTS}`, {
          moduleInfo: {
            current: "Welcome",
            activity: "welcome page continue button clicked",
            tcLink: this.defaultTandCLink,
            privacyLink: this.defaultPrivacyLink,
          },
        });
      } catch (err) {
        // fall through to finally
      } finally {
        this.continueLoading = false;
        if (showLoader) {
          this.$refs.loader?.hide();
        }
      }
    },
    async closeIframe() {
      // to handle the NestedIframe issue ACI
      await this.$store.dispatch(`user/${USER_TRACK_EVENTS}`, {
        moduleInfo: {
          current: routeEnum.WELCOME,
          activity: "iframe closed",
        },
      });
      this.notifyParentWindow({
        type: "rocketfuel_iframe_close",
        paymentCompleted: false,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.welcome-wrapper {
  box-sizing: border-box;
  //width: 365px;

  h1 {
    font-size: 30px;
    color: #1b1f3b;
    font-weight: 800;
    margin: 0;
  }

  .dropdown {
    margin-left: auto;
    width: 80%;
  }

  .sub-title {
    font-size: 20px;
    color: #515469;
    font-weight: 500;
  }

  .logo {
    img {
      margin-right: 15px;
    }

    font-size: 18px;
    font-weight: 600;
  }

  .header {
    margin-bottom: 40px;
    padding: 40px 20px 0;
  }

  .content {
    .continue-btn {
      width: 100%;
      margin: 5px;
      margin-bottom: 20px;
      padding: 10px;
    }
    .cancel-btn {
      background-color: #6e728b !important;
      border-color: #6e728b !important;
    }
  }

  .footer {
    padding: 0 20px;
    background-color: #efefef;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    .powered {
      font-size: 15px;
      color: #868686;
      display: block;
      padding: 10px 0;

      a {
        color: #27303d;
        text-decoration: underline;
      }
    }
  }

  .partner-block {
    margin-bottom: 35px;

    img {
      display: block;
      width: calc(33% - 30px);
      height: auto;
      object-fit: contain;
    }

    .logo-list {
      justify-content: space-between;
      height: 40px;
      margin: 10px 0;
    }

    .concordium-logo {
      transform: scale(1.3);
    }
  }
}

p {
  line-height: 18px;
  font-size: 14px;
  color: #6e728b;
  margin: 20px 0;
  text-align: justify;
}

.clearfix {
  text-align: center;

  .caption {
    font-size: 14px;
    margin: 10px 0;
    font-weight: 500;
  }
}

.link {
  text-decoration: underline;
  color: #ff7c00;
  font-size: 14px;

  &:hover {
    text-decoration: none;
    color: #ff7c00;
  }
}

.terms-conditions {
  display: flex;
  margin-bottom: 40px;

  input {
    vertical-align: middle;
    margin-right: 5px;
    margin-top: 3px;
  }

  span {
    font-size: 12px;
    color: #898ca1;

    .text-orange {
      color: #f0833c;
      font-weight: 500;
    }
  }
}
</style>
